import { create } from '@thoughtspot/logger';
import { validateTrackChartInteractionPayload } from './utils';
const logger = create('chart-to-ts > track-chart-interaction');
export const getTrackChartInteractionEventProcessor = (props) => {
    const { metricsService, isTsHostedChart } = props;
    const validateEventPayload = (eventData) => {
        const payload = eventData.payload;
        try {
            validateTrackChartInteractionPayload(payload, isTsHostedChart);
        }
        catch (err) {
            logger.warn(err);
            return {
                isValid: false,
                errors: [err.toString()],
            };
        }
        return {
            isValid: true,
        };
    };
    return {
        validateEventPayload,
        executeEvent: async (eventData) => {
            const payload = eventData.payload;
            const { eventName, mixpanelPayload } = payload;
            if (!metricsService) {
                logger.warn('MetricsService not available, skipping Mixpanel event:', eventName);
                return Promise.resolve();
            }
            metricsService.collectEvent({ name: eventName }, mixpanelPayload);
            logger.debug('Tracked chart interaction:', eventName, mixpanelPayload);
            return Promise.resolve();
        },
    };
};
//# sourceMappingURL=index.js.map